var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column_content about"},[_c('p',[_vm._v(_vm._s(_vm.$t('about')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }